import { apiClient } from './client';
import { API_ENDPOINTS } from './endpoints';
import { Prescription, CreatePrescriptionDto } from '../types/prescription.types';
import { Drug } from '../types/drug.types';
import { LabTest, RadiologyTest } from '../types/api.types';

export interface DrugDoseSuggestion {
  dose: string;
  duration: number;
  notes?: string;
  lastUsedDate: string;
}

export const prescriptionsApi = {
  getById: async (id: number): Promise<Prescription> => {
    const response = await apiClient.get<Prescription>(API_ENDPOINTS.PRESCRIPTION_BY_ID(id));
    return response.data;
  },

  getByVisitId: async (visitId: number): Promise<Prescription[]> => {
    const response = await apiClient.get<Prescription[]>(
      API_ENDPOINTS.PRESCRIPTIONS_BY_VISIT(visitId)
    );
    return response.data;
  },

  create: async (data: CreatePrescriptionDto): Promise<Prescription> => {
    const response = await apiClient.post<Prescription>(API_ENDPOINTS.PRESCRIPTIONS, data);
    return response.data;
  },

  getDrugDoseSuggestions: async (patientId: number, drugId: number): Promise<DrugDoseSuggestion[]> => {
    const response = await apiClient.get<DrugDoseSuggestion[]>(
      API_ENDPOINTS.DRUG_DOSE_SUGGESTIONS(patientId, drugId)
    );
    return response.data;
  },

  getInitialData: async (): Promise<{
    drugs: Drug[];
    labTests: LabTest[];
    radiologyTests: RadiologyTest[];
  }> => {
    const response = await apiClient.get<{
      drugs: Drug[];
      labTests: LabTest[];
      radiologyTests: RadiologyTest[];
    }>(API_ENDPOINTS.PRESCRIPTION_INITIAL_DATA);
    return response.data;
  },
};

